import { render, staticRenderFns } from "./Virtuell.vue?vue&type=template&id=4942d2e2&scoped=true"
import script from "./Virtuell.vue?vue&type=script&lang=js"
export * from "./Virtuell.vue?vue&type=script&lang=js"
import style0 from "./Virtuell.vue?vue&type=style&index=0&id=4942d2e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4942d2e2",
  null
  
)

export default component.exports